import type {IDynamicSiteItem} from '../_components/LazyLoading';
export const index: IDynamicSiteItem = {};
export default index;
